module.exports = ".row{\r\n    padding: 1em 0px 0px 0px !important;\r\n    margin-bottom: -3px;\r\n}\r\n\r\n\r\n.row:nth-child(odd){\r\n    background: #ececec;\r\n}\r\n\r\n\r\n.row:nth-child(even){\r\n    background: white;\r\n}\r\n\r\n\r\n.field-title{\r\n    width:200px;\r\n    display:inline-block;\r\n    color:#807f7f;\r\n}\r\n\r\n\r\n.mandatory{\r\n    color:red;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/maintainance-fee/maintainance-fee.component.css
// module id = ./src/app/allocation/maintainance-fee/maintainance-fee.component.css
// module chunks = main